import { BillingRoute } from '/@/modules/billing/constants/BillingRoute';
import { BillingRouteConfig } from '/@/modules/billing/routes/BillingRouteConfig';

export const router = [
  BillingRouteConfig.factory({
    path: `/${BillingRoute.DASHBOARD}`,
    name: BillingRoute.DASHBOARD,
    component: () => import('/@/modules/billing/pages/BillingDashboardPage.vue')
  }).build()
];
